module.exports = __webpack_public_path__ + "static/img/2.57f14df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/2/sp/2.png
// module id = jGIf
// module chunks = 0